<template>
  <div>
    <div class="row-v2">
      <div class="col">
        <div class="col__box">
          <div class="character clearfix" v-if="character">
            <div class="">
              <img :src="character.image || 'https://dummyimage.com/200x300'" class="character__avatar" :alt="character.name">
            </div>
            <div class="character__info">
              <h1>{{character.name}}</h1>
              <!-- <b>Total Movies:</b> {{character.movies_count || ''}}.<br> -->
              <b>Born:</b> {{character.born || ''}}.<br>
              <b>Description:</b> <span class="display-inline" v-html="character.description || 'N/A.'"></span><br>
              <b>Imdb url:</b> <a :href="character.imdb_url" :title="character.name" target="_blank" rel="noopener noreferrer">Imdb Url</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'characters-show',
  data() {
    return {
      character: {
        name: '',
      }
    };
  },
  methods: {
    async load() {
      let slug = this.$route.params.slug;
      this.$set(this, 'character', await window.api.characters[slug].get());
    }
  },
  watch: {
    $route() {
      this.load();
    }
  },
  created() {
    this.load();
  },
  metaInfo() {
    return {
      title: this.character.name,
    }
  },
}

</script>
